import type { MapBounds } from '../../components/layouts/MainPageLayout/MainLayoutContext';

export const isPointVisibleInBound = (regionCenter: { lat: number; lng: number }, bounds: MapBounds) => {
  return (
    regionCenter.lat >= bounds.southLat &&
    regionCenter.lat <= bounds.northLat &&
    regionCenter.lng >= bounds.westLng &&
    regionCenter.lng <= bounds.eastLng
  );
};
